module.exports = __webpack_public_path__ + "static/media/site-mgmt-icon.fb01402f.svg";